import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "./lib/i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Accommodations from "./pages/Accommodations";
import Guides from "./pages/Guides";
import Creator from "./pages/Creator";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Tours from "./pages/Tours";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { getToken } from "./lib/api";

const RequireAdmin = ({ children }) => (getToken() ? children : <Navigate to="/admin/login" replace />);

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/stays" element={<Accommodations />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/creators" element={<Creator />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/house-rules" element={<Legal pageKey="house" />} />
            <Route path="/cancellation" element={<Legal pageKey="cancel" />} />
            <Route path="/privacy" element={<Legal pageKey="privacy" />} />
            <Route path="/terms" element={<Legal pageKey="terms" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}
